module.exports = __webpack_public_path__ + "img/Millionaire-4.bff78e06.gif";